import jwt from '@/http/requests/auth/jwt'

export default {

  fetchSubscriptions ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.get('/api/subscription/list', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchSubscription (context, subscriptionId) {
    return new Promise((resolve, reject) => {
      const url = subscriptionId ? `/api/subscription/${subscriptionId}` : "/api/admin/subscription/new"
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createSubscription (context, data) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/subscription/create', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  requestPause (context, subscriptionId) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/subscription/pause', { id: subscriptionId })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  requestResume (context, subscriptionId) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/subscription/resume', { id: subscriptionId })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  requestStop (context, subscriptionId) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/subscription/stop', { id: subscriptionId })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord ({ commit }, subscriptionId) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/subscription/delete/${subscriptionId}`)
        .then((response) => {
          commit('REMOVE_RECORD', subscriptionId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  buy (context, payload) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/order/create', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  startPayment (context, payload) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/order/payment/start', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
